import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import InlineTextInput from '@/components/ui/inline-text-input';
import { useState } from 'react';

// name: string;
//   email: string;
//   phone: string;
//   lender_type: "bank" | "credit_union";

const LenderDialog = ({
  initialName,
  initialEmail,
  initialPhone,
  initialLenderType,
  onClickCta,
  ctaText,
  onOpen,
  onClose,
  dialogIsOpen,
  children,
}: {
  initialName: string;
  initialEmail: string;
  initialPhone: string;
  initialLenderType: 'bank' | 'credit_union';
  onClickCta: ({
    nameValue,
    emailValue,
    phoneValue,
    lenderTypeValue,
  }: {
    nameValue: string;
    emailValue: string;
    phoneValue: string;
    lenderTypeValue: 'bank' | 'credit_union';
  }) => void;
  ctaText: string;
  onOpen: () => void;
  onClose: () => void;
  dialogIsOpen: boolean;
  children?: React.ReactNode;
}) => {
  const [nameValue, setNameValue] = useState(initialName);
  const [emailValue, setEmailValue] = useState(initialEmail);
  const [phoneValue, setPhoneValue] = useState(initialPhone);
  const [lenderTypeValue, setLenderTypeValue] = useState(initialLenderType);

  return (
    <Dialog
      open={dialogIsOpen}
      // DEV NOTE: without modal `false` the dialog will make the entire page unresponsive
      // this is a known issue with shadcn/ui
      // especially if the dialog is opened within a combobox or dropdown
      // See: https://github.com/shadcn-ui/ui/issues/1912
      modal={false}
    >
      <DialogTrigger asChild onClick={onOpen}>
        {children}
      </DialogTrigger>
      <DialogContent
        className="sm:max-w-[425px]"
        onClickClose={onClose}
        onPointerDownOutside={onClose}
      >
        <DialogHeader>
          <DialogTitle>Lender</DialogTitle>
          <DialogDescription>Add a new lender to the deal.</DialogDescription>
        </DialogHeader>
        <InlineTextInput
          className="rounded text-xs"
          placeholder="Add Name"
          value={nameValue}
          onChange={(e) => setNameValue(e.target.value)}
        />
        <InlineTextInput
          className="rounded text-xs"
          placeholder="Add Email"
          value={emailValue}
          onChange={(e) => setEmailValue(e.target.value)}
        />
        <InlineTextInput
          className="rounded text-xs"
          placeholder="Add Phone"
          value={phoneValue}
          onChange={(e) => setPhoneValue(e.target.value)}
        />
        <InlineTextInput
          className="rounded text-xs"
          placeholder="Add Lender Type"
          value={lenderTypeValue}
          onChange={(e) =>
            setLenderTypeValue(e.target.value as 'bank' | 'credit_union')
          }
        />
        <DialogFooter>
          <Button
            type="submit"
            onClick={() =>
              onClickCta({
                nameValue,
                emailValue,
                phoneValue,
                lenderTypeValue,
              })
            }
          >
            {ctaText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LenderDialog;
